import { Slice, createSlice } from "@reduxjs/toolkit";
import { fetchGroundDataDetail } from "../thunk/SitesOverviewThunk";

const initialData: any = [];

const GroundDataReportSlice: Slice<any, {}, "GroundDataReportSlice"> = createSlice({
    name: "GroundDataReportSlice",
    initialState: { data: initialData, isLoading: false, error: "" },
    reducers: {},
    extraReducers(builder) {
        builder.addCase(fetchGroundDataDetail.pending, (state, action) => {
            state.isLoading = true
        });
        builder.addCase(fetchGroundDataDetail.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        });
        builder.addCase(fetchGroundDataDetail.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message ?? ""
        });
    }
})

export default GroundDataReportSlice
